export default __webpack_public_path__ + "static/nano-3159de5d585bb7c25fb9826cd93095ca.png";